import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";
import toast from "../../toast";

Vue.use(Vuex);

const actions = {
    async fetchChatRoomInfo({ commit }, payload) {
        try {
            const response = await axios.get(
                process.env.MIX_API_BASE_URL +
                    payload.chatNamespace +
                    "/conversation",
                {
                    params: {
                        ...payload.params
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching chat room info:", error);
            throw error;
        }
    },

    async fetchMessages({ commit }, payload) {
        try {
            const response = await axios.get(
                process.env.MIX_API_BASE_URL + payload.chatNamespace + "/message",
                {
                    params: {
                        ...payload.params
                    }
                }
            );
            const vacMessagesObjArray = response.data;
            return vacMessagesObjArray;
        } catch (error) {
            console.error("Error fetching deliverable messages:", error);
            throw error;
        }
    },

    async sendMessage({ commit }, payload) {
        try {
            const response = await axios.post(
                process.env.MIX_API_BASE_URL + payload.chatNamespace + "/message",
                payload.formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );
            if (response.data.errors) {
                const errorMessages = [];
                for (const key in response.data.errors) {
                    if (response.data.errors.hasOwnProperty(key)) {
                        const errorsArray = response.data.errors[key];
                        const combinedErrors = errorsArray.join(", ");
                        errorMessages.push(`${key}: ${combinedErrors}`);
                    }
                }
                console.error(response.data.message, errorMessages.join(", "));
                toast.error(errorMessages.join(", "));
                return false;
            } else {
                return response.data;
            }
        } catch (error) {
            console.error("Error submitting deliverable message:", error);
            throw error; // Rethrow the error to let the caller handle it
        }
    },

    async deleteMessage({ commit }, payload) {
        try {
            const response = await axios.delete(
                process.env.MIX_API_BASE_URL + payload.chatNamespace + "/message",
                payload
            );
            if (response.data.unauthorizedDeletion.length) {
                const separator =
                    response.data.unauthorizedDeletion.length > 1 ? ", " : "";
                const combinedUsernameString = response.data.unauthorizedDeletion.join(
                    separator
                );
                const errTitle = "Unauthorized!";
                const errMsg = `Some selected messages cannot be deleted. Only messages sent by you can be removed. Error deleting messages sent by: ${combinedUsernameString}`;
                toast.warning(errMsg, errTitle);
                console.warn(errTitle + errMsg);
            }
            return response.data;
        } catch (error) {
            console.error("Error deleting deliverable message:", error);
            throw error; // Rethrow the error to let the caller handle it
        }
    },

    async updateMessage({ commit }, payload) {
        try {
            const response = await axios.put(
                process.env.MIX_API_BASE_URL + payload.chatNamespace + "/message",
                payload
            );
            return response.data;
        } catch (error) {
            console.error("Error updating message:", error);
            throw error; // Rethrow the error to let the caller handle it
        }
    },

    async markAllAsRead({ commit }, payload) {
        try {
            const response = await axios.put(
                process.env.MIX_API_BASE_URL +
                    payload.chatNamespace +
                    "/conversation",
                payload
            );
            return response.data;
        } catch (error) {
            console.error("Error marking message as read:", error);
            throw error; // Rethrow the error to let the caller handle it
        }
    },

    
    async addNewChatParticipants({ commit }, payload) {
        try {
            const response = await axios.put(
                process.env.MIX_API_BASE_URL +
                    payload.chatNamespace +
                    "/participant",
                payload
            );
            return response.data;
        } catch (error) {
            console.error("Error adding new participants to conversation:", error);
            throw error; // Rethrow the error to let the caller handle it
        }
    },

    async getLastMessage({ commit }, payload) {
        try {
            const response = await axios.get(
                process.env.MIX_API_BASE_URL +
                    payload.chatNamespace +
                    "/conversation/message",
                {
                    params: {
                        ...payload.params
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching last message:", error);
            throw error;
        }
    }
};

export const deliverableChat = {
    actions,
    namespaced: true,
};

export const projectChat = {
    actions,
    namespaced: true,
};
